(() => {
  const root = document.querySelector('.be-neo-landing') || document;
  const offers = [...root.querySelectorAll('.be-bundle')];
  const purchaseButton = root.querySelector('#BeNeoPurchaseButton');
  let toastTimer;

  const selectedInput = () => root.querySelector('input[name="be-offer"]:checked');

  function updateOffer(input) {
    offers.forEach((offer) => offer.classList.toggle('selected', offer.contains(input)));
  }

  offers.forEach((offer) => {
    const input = offer.querySelector('input');
    input?.addEventListener('change', () => updateOffer(input));
  });

  const toast = document.createElement('div');
  toast.className = 'be-purchase-toast';
  toast.setAttribute('role', 'status');
  toast.setAttribute('aria-live', 'polite');
  toast.innerHTML = '<span>✓</span><div><b>One-time option selected</b><small></small></div><button type="button" aria-label="Close">×</button>';
  document.body.appendChild(toast);

  function hideToast() {
    toast.classList.remove('show');
  }

  toast.querySelector('button')?.addEventListener('click', hideToast);

  purchaseButton?.addEventListener('click', (event) => {
    event.preventDefault();
    const input = selectedInput();
    const detail = {
      offer: input?.value || 'Buy 1',
      price: input?.dataset.price || '$44.95',
      purchaseType: 'one-time',
    };
    const integrationEvent = new CustomEvent('be-neo:purchase', {
      detail,
      bubbles: true,
      cancelable: true,
    });
    purchaseButton.dispatchEvent(integrationEvent);

    if (!integrationEvent.defaultPrevented) {
      toast.querySelector('small').textContent = `${detail.offer} · ${detail.price} · ready to connect to your Shopify product.`;
      toast.classList.add('show');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(hideToast, 4200);
    }
  });

  const viewer = root.querySelector('[id^="GalleryViewer-"]');
  const slideList = viewer?.querySelector('.product__media-list');
  const slides = viewer ? [...viewer.querySelectorAll('.product__media-item')] : [];
  const thumbnailGallery = root.querySelector('[id^="GalleryThumbnails-"]');
  const thumbnailItems = thumbnailGallery ? [...thumbnailGallery.querySelectorAll('.thumbnail-list__item')] : [];
  const dots = viewer ? [...viewer.querySelectorAll('.slider__dots button')] : [];
  let activeSlide = 0;

  function activateSlide(index, scroll = true) {
    if (!slides.length) return;
    activeSlide = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === activeSlide));
    thumbnailItems.forEach((item, itemIndex) => {
      const button = item.querySelector('button');
      if (!button) return;
      if (itemIndex === activeSlide) button.setAttribute('aria-current', 'true');
      else button.removeAttribute('aria-current');
    });
    dots.forEach((dot, dotIndex) => {
      dot.classList.toggle('active', dotIndex === activeSlide);
      if (dotIndex === activeSlide) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
    if (scroll && slideList) {
      slideList.scrollTo({ left: slides[activeSlide].offsetLeft, behavior: 'smooth' });
    }
  }

  thumbnailItems.forEach((item, index) => {
    item.querySelector('button')?.addEventListener('click', () => activateSlide(index));
  });
  dots.forEach((dot, index) => dot.addEventListener('click', () => activateSlide(index)));
  viewer?.querySelector('.slider-button--prev')?.addEventListener('click', () => activateSlide(activeSlide - 1));
  viewer?.querySelector('.slider-button--next')?.addEventListener('click', () => activateSlide(activeSlide + 1));

  const thumbnailList = thumbnailGallery?.querySelector('.thumbnail-list');
  thumbnailGallery?.querySelector(':scope > .slider-button--prev')?.addEventListener('click', () => {
    thumbnailList?.scrollBy({ left: -300, behavior: 'smooth' });
  });
  thumbnailGallery?.querySelector(':scope > .slider-button--next')?.addEventListener('click', () => {
    thumbnailList?.scrollBy({ left: 300, behavior: 'smooth' });
  });
  activateSlide(0, false);

  root.querySelectorAll('.rcw-nav button').forEach((button, index) => {
    button.addEventListener('click', () => {
      root.querySelector('#rcwScroll')?.scrollBy({ left: index === 0 ? -300 : 300, behavior: 'smooth' });
    });
  });

  const shipDate = root.querySelector('#ship-date');
  if (shipDate) {
    const date = new Date();
    date.setDate(date.getDate() + 3);
    shipDate.textContent = date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  root.querySelectorAll('a[href="#"]').forEach((link) => {
    link.addEventListener('click', (event) => event.preventDefault());
  });

  root.querySelectorAll('img').forEach((image) => {
    image.addEventListener('error', () => image.classList.add('be-image-error'));
  });

  const title = root.querySelector('.product__title h1, h1.product__title');
  if (title) title.textContent = 'Be Neo Oregano & Black Seed Oil';

  updateOffer(selectedInput());
})();
